import { render, staticRenderFns } from "./CmhLogoBackground.vue?vue&type=template&id=84f5f1d0"
import script from "./CmhLogoBackground.vue?vue&type=script&lang=ts"
export * from "./CmhLogoBackground.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports